(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-inline"] && !Shopify.designMode) return;
  try {
    // ARTPLEX: Handle click outside to close dropdown
  document.addEventListener('click', (e) => {
    const searchComponents = document.querySelectorAll('.artplex-inline-search__component');
    searchComponents.forEach(component => {
      if (!component.contains(e.target)) {
        const input = component.querySelector('.artplex-inline-search__input');
        if (input && document.activeElement === input) {
          input.blur();
        }
      }
    });
  });

  // Handle escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const activeInput = document.querySelector('.artplex-inline-search__input:focus');
      if (activeInput) {
        activeInput.blur();
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
